var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserExpert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.99977,105 C104.99977,105 104.91277,100.498 104.99977,95 C105.08677,89.502 103.72677,87.615 94.7567699,81.622 L69.9997699,65 C80.0777699,60.16 79.9117699,50.521 79.9997699,45 L79.9997699,35 C80.0877699,29.479 78.4817699,23.914 74.9187699,20.237 C71.3587699,16.562 65.5217699,15.088 59.9997699,15 C54.4807699,15.088 48.6447699,16.562 45.0847699,20.237 C41.5207699,23.914 39.9157699,29.479 40.0037699,35 L40.0037699,45 C40.0917699,50.521 39.9257699,60.16 50.0037699,65 L25.2477699,81.622 C16.2767699,87.615 14.9167699,89.502 15.0037699,95 C15.0907699,100.498 15.0037699,105 15.0037699,105 L104.99977,105 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80 70 60 85 60.001 105 60 85 40 70"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExpert);
export default __webpack_public_path__ + "static/media/user-expert.9173caa3b8cb65dca2a81d251282b733.svg";
export { ForwardRef as ReactComponent };